import Vue from 'vue'
import Vuex from 'vuex'

import api from '../api'

//const Vue = require('vue')
//const Vuex = require('vuex')

Vue.use(Vuex)

const store = new Vuex.Store({
  // 初始化的数据
  state: {
    token: null,
    user: null,
    loginFormVisible: false,
    favorite: []
  },
  // 改变state里面的值得方法
  mutations: {
    login(state, data) {
      state.user = data
    },
    logout(state) {
      state.token = null
      state.user = null
      localStorage.clear()
    },
    loginFormVisible(state, data) {
      state.loginFormVisible = data
    },
    token(state, data) {
      state.token = data
    },
    init(state) {
      api.favorite.getList().then(r => {
        state.favorite = r
      })
    },
    initFavorite(state) {
      api.favorite.getList().then(r => {
        state.favorite = r
      })
    }
  }
})
// 输出模块
export default store



// WEBPACK FOOTER //
// ./src/store/store.js